<template>
  <div class="search-input">
    <div class="search-area">
      <el-input v-model="input"
                placeholder="请输入想要检索的内容"
                data-warden-title="检索结果"
                :data-warden-info="`全部检索--${input}`"
                class="search-input-box"
                @keyup.enter.native="search(input)"
                pre>
        <img slot="prefix"
             src="@/assets/images/search.png"
             alt="search"
             class="search-icon">
      </el-input>
      <button class="search-button"
              data-warden-title="检索结果"
              :data-warden-info="`全部检索--${input}`"
              @click="search(input)">
        检索
      </button>
    </div>
    <div class="search-recommend">
      <span>热词推荐：</span>
      <div v-for="item in lables"
           :key="item"
           class="recommend-item"
           data-warden-title="检索结果"
           :data-warden-info="`全部检索--${item}`"
           @click="search(item)">
        {{ item }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SearchInput',
  props: {},
  data () {
    return {
      input: '',
      lables: [
        '岭南卫生方',
        '黄帝内经',
        '伤寒论',
        '神农本草经',
        '伤寒杂病论',
        '本草纲目'
      ]
    }
  },
  methods: {
    search (item) {
      let routeUrl = this.$router.resolve({
        path: '/retrieve/retrievehome/retrieveResult',
        query: {
          searchText: item,
          command: 'all',
          exactSearch: 1
        }
      })
      window.open(routeUrl.href, '_blank')
    }
  }
//   mounted () {
//     this.input = this.$route.query.searchText
//   }
}
</script>

<style scoped>
.search-input {
  border-top: 10px solid #eee1d3;
  background-color: #f3e9de;
  width: 1048px;
  margin: 0 auto;
  margin-bottom: 36px;
  padding: 10px 76px;
}

.search-icon {
  width: 20px;
  height: 20px;
}

.search-area {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 45px;
}

.search-input >>> .el-input__prefix {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 10px;
}

.search-input >>> .el-input__inner {
  border: none;
  border-radius: 22.5px 0 0 22.5px;
  height: 45px;
  font-size: 16px;
  padding-left: 70px;
  color: #000;
}

.search-input >>> .el-input__inner:focus {
  border: none;
  box-shadow: none;
}

.search-input >>> .el-input__inner::placeholder {
  color: #d2cbc5;
}

.search-button {
  width: 100px;
  height: 45px;
  border: none;
  border-radius: 0 22.5px 22.5px 0;
  background-color: #9e5c1d;
  color: #fff;
  font-size: 16px;
  cursor: pointer;
  margin-left: 8px;
}

.search-recommend {
  display: flex;
  align-items: center;
  margin-top: 10px;
}

.search-recommend span {
  font-size: 16px;
  color: #9e5c1d;
}

.recommend-item {
  display: flex;
  justify-content: center;
  align-items: center;
  /* margin-left: 30px; */
  font-size: 16px;
  height: 36px;
  color: #634C37;
  /* background-color: #e3d9cd; */
  padding: 0 20px;
  border-radius: 18px;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/SearchInput.vue